<template>
  <v-container>
    <v-card
      v-for="article in articles"
      :key="article.id"
      class="mx-auto news"
    >
      <v-img
        class="white--text align-end"
        height="30vh"
        :src="getImage(article)"
      />

      <v-card-subtitle class="pb-0">
        {{getDate(article)}}
      </v-card-subtitle>

      <v-card-title>{{language =='Ελληνικά'? article.title : article.titleEn}}</v-card-title>

      <v-card-text class="text--primary" v-if="article.body || article.bodyEn">
        <span v-html="language =='Ελληνικά'? article.body.substring(0, 70)+ '...' : article.bodyEn.substring(0, 70)+ '...'"></span>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="orange"
          text
          @click="goToArticle(article.id)"
        >
          {{language =='Ελληνικά'? "ΔΙΑΒΑΣΕ" : "READ"}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>


<script>
  import restApi from "@/rest-api";

  export default {
    props: {
        language: String
    },
    data() {
        return {
            articles:[]
        }
    },
    created() {
      this.fetchArticles();
    },
    methods: {
      fetchArticles() {
        var search = `/article/all`;
        restApi
        .get(search)
        .then(response => {
              this.articles = response.data
        })
        .catch((error) => {
            console.log(error);
        });
      },
      goToArticle(id) {
        this.$router.push({name: 'Article', query: { articleId: id }});
      },
      getImage(article) {
        if(article.image) {
          return `https://dev.aggelopoulos-sarantis.com/uploads/images/${article.image.imageName}`
        } else {
          return require("@/assets/default.png")
        }
      },
      getDate(article) {
        var date = new Date(article.createdAt)
        return date.getDate()+
          "/"+(date.getMonth()+1)+
          "/"+date.getFullYear()
      },
    }
  }
</script>

<style lang="scss" scoped>
    @media only screen and (min-width: 600px){
        .news{
            margin-top: 7%;
            width: 50vw;
            height: auto;
            margin-bottom: 7%;
        }
    }

    @media only screen and (max-width: 600px){
        .news{
            margin-top: 30%;
            width: 90vw;
            height: auto;
            margin-bottom: 10%;
        }
    }
</style>